function fetchDataLayer(apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/analytics/dataLayer`;
  return apiClient.get(route);
}

export default { fetchDataLayer };
